const isApiEndpointStaging = (): boolean => {
    const envSquadded = localStorage.getItem('envSquadded')
    return envSquadded === 'STAGING' || envSquadded === 'DEV' || window.location.hostname === 'localhost';
};
const calcUsermediaCdnRoot = (): string => {
    const prodCdn = 'http://d3btag7750v7t0.cloudfront.net';
    const stagingCdn = 'https://d9pi2lve58hwn.cloudfront.net';
    return isApiEndpointStaging() ? stagingCdn : prodCdn;
};
export const getMediaFullUrl = (url: string): string => {
    const startsWithHttps = new RegExp(`^https://`, 'i');
    if (!url || startsWithHttps.test(url)) {
        return url;
    }
    return `${calcUsermediaCdnRoot()}${url.charAt(0) === '/' ? url : '/' + url}`;
};